export default __webpack_public_path__ + "static/media/Corporate_Presentation_May2023_v2.928b4dab.pdf";